export const COMPETENCY_LABELS = {
  technical: "Technical",
  coding: "Coding",
  problem_solving: "Problem Solving",
  communication: "Communication",
  behavioural: "Behavioural",
  confidence: "Confidence",
  role_fit: "Role Fit",
};

export const COMPETENCY_ORDER = [
  "technical", "coding", "problem_solving", "communication", "behavioural", "confidence", "role_fit",
];

export function levelMeta(score) {
  if (score == null) return { label: "Not Started", color: "#94A3B8", bg: "#F1F5F9", text: "#475569" };
  if (score >= 85) return { label: "Interview Ready", color: "#10B981", bg: "#D1FAE5", text: "#065F46" };
  if (score >= 70) return { label: "Almost Ready", color: "#F59E0B", bg: "#FEF3C7", text: "#92400E" };
  if (score >= 50) return { label: "Needs Improvement", color: "#EF4444", bg: "#FEE2E2", text: "#991B1B" };
  return { label: "Early Preparation", color: "#94A3B8", bg: "#F1F5F9", text: "#475569" };
}

export function scoreColor(v) {
  if (v >= 85) return "#10B981";
  if (v >= 70) return "#F59E0B";
  if (v >= 50) return "#EF4444";
  return "#94A3B8";
}
